
import React, { useEffect, useState, useRef } from "react";
import API from '../Services/Product'
import ProductType from "../Components/ProductType";
import TaxRateListList from "../Components/TaxRate";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment";
import APIS from '../Services/SalesTab'
import APISS from '../Services/Location'
import APISSS from '../Services/ProductType'
import APIMACHINE from '../Services/MachineMaster'
import DisplayOrder from '../Components/DisplayOrder'
import ProductList from "../Components/ProductList";
import SalesProductType from "../Components/SaleProductType";
import SalesComboProductType from "../Components/SaleComboProductType";


const Product = () => {
    const [name, setName] = useState("")
    const [productType, setProductType] = useState([])
    const [displayOrder, setDisplayOrder] = useState([])
    const [playPoint, setPlayPoint] = useState("")
    const [description, setDescription] = useState("")
    const [isRecipe, setIsRecipe] = useState("")
     const [curiousKids, setCuriousKids] = useState("")
    const [error, setError] = useState({});
    const perPage = 10

    const [currentPage, setCurrentPage] = useState(1);
    const [comboName, setComboName] = useState("")
    const [comboProductType, setComboProductType] = useState([])
    const [comboDisplayOrder, setComboDisplayOrder] = useState([])
    const [comboPrice, setComboPrice] = useState("")
    const [comboTax, setComboTax] = useState("")
    const [comboTime, setComboTIme] = useState("min")
    const [rows, setRows] = useState([]);
    const [searchProductType, setSearchProductType] = useState([])
    const [currentPage1, setCurrentPage1] = useState(1);
    const [totalRecords1, setTotalRecords1] = useState(0);
    const [searchProductList, setSearchProductList] = useState([])
    const [selectTime, setSelectTime] = useState([])
    const [timeOptions, setTimeOptions] = useState([]);
    const [isEditingCombo, setIsEditingCombo] = useState(false);
    const [isAddProductList, setIsAddProductList] = useState(true);
    const [isModal, setIsModal] = useState(false)
    const [salesTab, setSalesTab] = useState([])
    const [salesTab1, setSalesTab1] = useState([])
    const [selectSalesTab, setSelectSalesTab] = useState(null)
    const [location, setLocation] = useState([])
    const [location1, setLocation1] = useState([])
    const [changePlayPoint, setChangePlayPoint] = useState("SkyCoins")
    const [timeValue, setTimeValue] = useState(Number);
    const [timeValue1, setTimeValue1] = useState(Number);

    const [machine, setMachine] = useState([])
    const [selectMachine, setSelectMachine] = useState("");
    const [activeSection, setActiveSection] = useState('single');

    const [selected, setSelected] = useState([]);
    const [selectAll, setSelectAll] = useState(false);
    const [getSelectAll, setGetSelectAll] = useState(false);

    const [selectedCombo, setSelectedCombo] = useState([]);
    const [selectAllCombo, setSelectAllCombo] = useState(false);
    const [getSelectAllCombo, setGetSelectAllCombo] = useState(false);

    const [selectedComboProductTypes, setSelectedComboProductTypes] = useState([]);
    const [mrp, setMrp] = useState("");
    const [enableParty, setEnableParty] = useState("")

    const [selectcomboSalesTab, setSelectcomboSalesTab] = useState("")
    const [singleTax, setSingleTax] = useState("")

    const [locationData, setLocationData] = useState("");
    const [refresh, setRefresh] = useState(false);
    const [selectedcomboProductType, setSelectedcomboProductType] = useState([])
    const [skycoinsSpcl, setSkycoinsSpcl] = useState();
    const [comboSpecialPrice, setComboSpecialPrice] = useState(0);
    const [showSubProduct, setShowSubProduct] = useState(false)
    const [trackInventory, setTrackInventory] = useState(false);

    useEffect(() => {
        getTimeData()
    }, [currentPage])

    useEffect(() => {
        bindLocation()
    }, [])

    const bindLocation = async () => {
        try {
            const response = await APISS.getLocationList({
                is_active: 1,
                limit: 0,
            });
            setLocation(response?.data?.data || []);
            setLocation1(response?.data?.data || [])
        } catch (error) {
            setError("Failed to fetch locations.");
            console.error(error);
            if (error.response.status == 403) {
                window.location.replace("/Login");
            }
        }
    };

    const getSalesTab = async (location) => {
        try {
            if (location === "Select") {
                setSalesTab([]);
                return;
            }
            const location_ids = Array.isArray(location) ? location.join(",") : location;
            const isMultiple = location_ids.length === 1 ? 0 : 1;
            const response = await APIS.Sales_Tab_List({
                is_active: 1,
                limit: 0,
                pageNumber: 1,
                location_ids,
                is_multiple: isMultiple,
                is_combo: 0

            });
            // console.log('response',response)
            setSalesTab(response?.data?.data || []);
            //console.log('response?.data?.data sales tab', response?.data?.data);

        } catch (error) {
            setError((prev) => ({ ...prev, salesTab: "Failed to fetch sales tab data." }));
            handleError(error);
            if (error.response.status == 403) {
                window.location.replace("/Login");
            }
        }
    };

    const getSalesTab1 = async (location1) => {
        try {
            const location_ids = Array.isArray(location1) ? location1.join(",") : location1;
            const isMultiple = location_ids.length === 1 ? 0 : 1;
            setLocationData(location_ids);
            const response = await APIS.Sales_Tab_List({
                is_active: 1,
                limit: 0,
                pageNumber: 1,
                location_ids,
                is_multiple: isMultiple,
                is_combo: 1
            });
            setSalesTab1(response?.data?.data || []);
            setRefresh(true);

            //  console.log('setSalesTab1', response?.data?.data);
        } catch (error) {
            setError((prev) => ({ ...prev, salesTab: "Failed to fetch sales tab data." }));
            handleError(error);
            if (error.response.status == 403) {
                window.location.replace("/Login");
            }
        }
    };

    const handleFieldChange = (e, fieldName) => {
        const value = e.target.value;
        // console.log("value data", value)
        setComboTIme(value)
        if (value.trim()) {
            setError((prevErrors) => {
                const updatedErrors = { ...prevErrors };
                delete updatedErrors[fieldName];
                return updatedErrors;
            });
        }

        switch (fieldName) {
            case "name":
                setName(value);
                break;
            case "productType":
                setProductType(value);
                break;
            case "displayOrder":
                setDisplayOrder(value);
                break;
            case "playPoint":
                setPlayPoint(value);
                break;
            case "description":
                setDescription(value);
                break;
            case "comboTime":
                setComboTIme(value);
                break;
            case "timeValue":
                setTimeValue(value);
                break;
            case "timeValue1":
                setTimeValue1(value);
                break;
            case "mrp":
                setMrp(value);
                break;
            case "singleTax":
                setSingleTax(value);
                break;
            case "skycoinsSpcl":
                setSkycoinsSpcl(value);
                break;
            // case "selectMachine":
            //     setSelectMachine(value);
            //     if (value === "Select") {
            //         // setSelectMachine(null);
            //         setSelectMachine("");
            //         setIsRecipe(false);
            //     }
            //     else {
            //         setSelectMachine(value);
            //     }
            //break;
            default:
                break;
        }
    };
    const validateFields = () => {
        const errors = {};
        if (!name.trim()) {
            errors.name = "Name is required";
        }
        if (!playPoint.trim()) {
            errors.playPoint = `${changePlayPoint} is required`;
        } else if (isNaN(playPoint)) {
            errors.playPoint = `${changePlayPoint} must be a numeric value`;
        }
        if (changePlayPoint.trim() === 'Ticket') {
            if (!mrp || !mrp.toString().trim()) {
                errors.mrp = "MRP is required";
            } else if (isNaN(mrp)) {
                errors.mrp = "MRP must be a numeric value";
            }
        }
        // if (!playPoint.trim()) {
        //     errors.playPoint = {changePlayPoint}" is required";
        // } else if (isNaN(playPoint)) {
        //     errors.playPoint = "Play Point must be a numeric value";
        // }
        setError(errors);
        return Object.keys(errors).length === 0;
    };

    const handleError = (error) => {
        console.error("Error:", error);
        if (error.response) {
            toast.error(error.response.data?.message || `Error: ${error.response.status}`);
        } else if (error.request) {
            toast.error("No response from server. Please try again later.");

        } else {
            toast.error("Something went wrong. Please try again.");
        }
    };
    const addSingldProduct = async () => {
        let updatedIsRecipe = isRecipe;
        if (isRecipe === "") {
            updatedIsRecipe = false;
        }

        if (!validateFields()) return;
        if (!productType || productType.length === 0) {
            toast.error("Product type is required");
            return;
        }
        if (!singleTax || singleTax.length === 0) {
            toast.error("Tax Rate is required11");
            return;
        }
        const timeInMinutes = Number(timeValue) * 60;
        const time = timeInMinutes + Number(timeValue1);
        const isMultiple = productType.length === 1 ? 0 : 1;
        const payload = {
            company_id: 1,
            name: name,
            product_type_id: productType,
            display_order: 0,
            amount: parseInt(playPoint) || 0,
            time: time || 0,
            payment_type_id: 1,
            is_combo: false,
            // tax_type_id: 1,
            //track_inventory: false,
            // is_recipe: updatedIsRecipe,
            track_inventory: trackInventory ? true : false,
            is_recipe: isRecipe ? true : false,
            description: description,
            mrp: parseInt(mrp) || null,
            //  is_party: updateEnableParty,
            is_multiple: isMultiple,
            tax_type_id: singleTax,
            special_price: parseFloat(skycoinsSpcl),
            curiousKids:curiousKids ? true : false
        }
        // console.log("payload data singl Product..", payload)
        //return
        try {
            const response = await API.addProduct(payload);
            // console.log("Response product type:", response);
            toast.success(response?.data?.message || "Product created successfully!");
            setTimeout(() => window.location.reload(), 2000);
        } catch (error) {
            handleError(error);
            // console.log("error", error)
            if (error.response.status == 403) {
                window.location.replace("/Login");
            }
        }
    };

    useEffect(() => {
        if (searchProductType) {
            handleSearch(searchProductType, currentPage1);
        }
    }, [currentPage1]);


    const handleSearch = async (product_type_id, page) => {
        if (!product_type_id || product_type_id.length === 0) {
            return;
        }
        setIsModal(true);
        const payload = {
            limit: perPage,
            pageNumber: page,
            product_type_id: product_type_id,
        };

        try {
            const response = await API.Get_Product(payload);
            if (response.data && response.data.data) {
                setSearchProductList(response.data.data);
                setTotalRecords1(response.data.totalCount);
                setIsModal(true);
            } else {
                toast.error("No data found.");
            }
        } catch (error) {
            if (error.response.status == 403) {
                window.location.replace("/Login");
            }
            console.error('Error fetching products:', error);
            toast.error("An error occurred while searching for products.");
        }
    };
    
    const handleSearchClick = () => {
        if (!searchProductType || searchProductType.length === 0) {
            toast.error("Please select a Product Type.");
            return;
        }
        handleSearch(searchProductType, currentPage1);
    }
    const totalPages1 = Math.ceil(totalRecords1 / perPage);
    const handlePageChange1 = (page) => {
        if (page > 0 && page <= totalPages1) {
            setCurrentPage1(page);
            handleSearch(searchProductType);
            //getProductList();
        }
    };

    const handleInputChange = (index, field, value) => {
        const updatedRows = rows.map((row, i) =>
            i === index ? { ...row, [field]: value } : row
        );
        setRows(updatedRows);

        if (field === "discounted_price" || field === "qty") {
            const total = updatedRows.reduce((sum, row) => {
                const price = parseFloat(row.discounted_price || 0);
                const qty = parseFloat(row.qty);
                const validQty = isNaN(qty) || qty === 0 ? 1 : qty;

                const rowTotal = price * validQty;
                return sum + (isNaN(rowTotal) ? 0 : rowTotal);
            }, 0);

            setComboPrice(total.toFixed(2));
        }

        if (field === "discounted_price_special" || field === "qty") {
            const total = updatedRows.reduce((sum, row) => {
                const price = parseFloat(row.discounted_price_special || 0);
                const qty = parseFloat(row.qty);
                const validQty = isNaN(qty) || qty === 0 ? 1 : qty;

                const rowTotal = price * validQty;
                return sum + (isNaN(rowTotal) ? 0 : rowTotal);
            }, 0);

            setComboSpecialPrice(total.toFixed(2));
        }
    };

    const handleFieldChange1 = (e, fieldName) => {
        const value = e.target.value;
        if (value.trim()) {
            setError((prevErrors) => {
                const updatedErrors = { ...prevErrors };
                delete updatedErrors[fieldName];
                return updatedErrors;
            });
        }

        switch (fieldName) {
            case "comboName":
                setComboName(value);
                break;
            case "comboProductType":
                setComboProductType(value);
                break;
            case "comboDisplayOrder":
                setComboDisplayOrder(value);
                break;
            // case "comboPrice":
            //     setComboPrice(value);
            //     break;
            case "comboTax":
                setComboTax(value);
                break;
            default:
                break;
        }
    };
    const validateFields1 = () => {
        const errors = {};
        if (!comboName.trim()) errors.comboName = "Name is required";
        // if (!comboPrice.trim()) {
        //     errors.comboPrice = "Price is required";
        // } else if (isNaN(comboPrice)) {
        //     errors.comboPrice = "Price must be a valid number";
        // } else if (parseFloat(comboPrice) <= 0) {
        //     errors.comboPrice = "Price must be greater than 0";
        // }
        setError(errors);
        return Object.keys(errors).length === 0;
    };

    const addComboProduct = async () => {
        // console.log('selectedcomboProductType', selectedcomboProductType);
        if (!validateFields1()) return;
        if (!comboProductType || comboProductType.length === 0 || comboProductType == 'Select') {
            toast.error("Product type is required");
            return;
        }

        if (!searchProductType || searchProductType.length === 0) {
            toast.error("Please select a Sub Product Type.");
            return;
        }

        if (!selectTime) toast.selectTime = "Select Time is required"

        for (let row of rows) {
            const sub_product_time =
                (parseInt(row.hours) || 0) * 60 + (parseInt(row.minutes) || 0) || row.time || 0;
            if (sub_product_time === 0) {
                if (!row.qty || isNaN(row.qty) || row.qty <= 0) {
                    toast.error("Quantity must be a valid number greater than 0.");
                    return;
                }
                if (!row.discounted_price || isNaN(row.discounted_price) || row.discounted_price <= 0) {
                    toast.error("Discounted Price must be a valid number.");
                    return;
                }
            }
        }
        const comboList = rows.map(row => (
            {
                id: row.id,
                qty: row.qty || 0,
                //sub_product_time: parseInt(row.hours) * 60 + parseInt(row.minutes) || row.time
                sub_product_time: parseInt(row.hours || 0) * 60 + parseInt(row.minutes || 0) || row.time,
                offered_price: row.discounted_price,
                discounted_price_special: parseFloat(row.discounted_price_special)
            }));

        if (comboList.length === 0) {
            toast.error("Please select at least one sub-product.");
            return;
        }
        const product_type_id = selectedcomboProductType;
        const isMultiple = product_type_id.length === 1 ? 0 : 1;

        const payload = {
            company_id: 1,
            name: comboName,
            product_type_id: product_type_id,
            display_order: parseInt(0),
            amount: parseInt(comboPrice),
            payment_type_id: 1,
            is_combo: true,
            tax_type_id: null,
            //tax_type_id: comboTax,
            track_inventory: true,
            is_recipe: false,
            comboList,
            is_multiple: isMultiple,
            special_price: parseFloat(comboSpecialPrice)
        };
        try {
            const response = await API.addProduct(payload);
            toast.success(response?.data?.message || "Product created successfully!");
            setTimeout(() => window.location.reload(), 2000);
        } catch (error) {
            handleError(error);
            if (error.response.status == 403) {
                window.location.replace("/Login");
            }
            console.log("error", error)
        }
    }

    const recalculateComboPrices = (rowsData) => {
        const totalNormal = rowsData.reduce((sum, row) => {
            const price = parseFloat(row.discounted_price || 0);
            const qty = parseFloat(row.qty || 1);
            return sum + price * (qty === 0 ? 1 : qty);
        }, 0);

        const totalSpecial = rowsData.reduce((sum, row) => {
            const price = parseFloat(row.discounted_price_special || 0);
            const qty = parseFloat(row.qty || 1);
            return sum + price * (qty === 0 ? 1 : qty);
        }, 0);

        setComboPrice(totalNormal.toFixed(2));
        setComboSpecialPrice(totalSpecial.toFixed(2));
    };

    const handleRemoveRow = (index) => {
        const updatedRows = rows.filter((_, i) => i !== index);
        setRows(updatedRows);
        recalculateComboPrices(updatedRows);
    };

    const handleAddRow = async (id, productName, time, type) => {
        const isAlreadyAdded = rows.some(row => row.id === id);
        if (isAlreadyAdded) {
            toast.error("Product already added");
            return;
        }
        if (type === 'up') {
            try {
                setRows([]);
                const response = await API.getSubProduct(id);
                // console.log("response data upppp..", response?.data?.data?.rows)
                const details = response?.data?.data?.rows || [];
                if (details.length === 0) {
                    console.warn("No sub-products found");
                    return;
                }
                const newRows = details.map(item => {
                    const totalMinutes = item.time || 0;
                    const hours = Math.floor(totalMinutes / 60);
                    const minutes = totalMinutes % 60;
                    return {
                        id: item.product_id,
                        productName: item.product_name,
                        hours: hours,
                        minutes: minutes,
                        qty: item.quantity ? item.quantity : "0",
                    };
                });
                setRows(prevRows => [...prevRows, ...newRows]);
                // setShowSubProduct(true);
            } catch (error) {
                console.error("Error fetching sub-products:", error);
            }
        }
        else {
            const newRow = {
                id: id,
                productName: productName,
                time: time,
                quantity: "",
            };
            toast.success('Product Added Successfully');
            setRows(prevRows => [...prevRows, newRow]);
            // setShowSubProduct(true);
        }
    }

    const getTimeData = async () => {
        try {
            const response = await API.getTime();
            setTimeOptions(response?.data?.data || []);
        } catch (error) {
            if (error.response.status == 403) {
                window.location.replace("/Login");
            }
            console.error("Error fetching time data:", error);
        }
    };

    const productTypeFlag2 = 'All';
    const productTypeFlag = false;
    const productTypeFlag1 = true;

    const handleCancel = () => {
        window.location.reload();
    }
    const staticHours = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"];
    const staticMinutes = ["0", "15", "30", "45",];


    const buttonStyle = (type) => ({
        padding: '10px 20px',
        marginRight: '10px',
        cursor: 'pointer',
        backgroundColor: activeSection === type ? '#2c03fc' : '#555555',
        color: activeSection === type ? '#ffffff' : '#ffffff',
        border: 'none',
        borderRadius: '4px',
        fontWeight: 'bold',
        transition: 'background-color 0.3s ease, color 0.3s ease',
    });

    const handleCheckboxChange = (id) => {
        const updated = [...selected];
        const locationIndex = location.findIndex((loc) => loc.id === id);
        updated[locationIndex] = !updated[locationIndex];
        setSelected(updated);
        setSelectAll(updated.filter(Boolean).length === location.length);
        const selectedLocationIds = location
            .map((loc, index) => (updated[index] ? loc.id : null))
            .filter((id) => id !== null);
    };
    const handleSelectAll = (e) => {
        const checked = e.target.checked;
        setSelectAll(checked);
        const updatedSelected = new Array(location.length).fill(checked);
        setSelected(updatedSelected);
        if (checked) {
            const allLocationIds = location.map((loc) => loc.id);
            //  console.log("All Selected Location IDs:", allLocationIds);
        } else {
            console.log("No locations selected");
        }
    };

    const handleOk = () => {
        const selectedLocationIds = location
            .map((loc, index) => (selected[index] ? loc.id : null))
            .filter((id) => id !== null);
        setGetSelectAll(selectedLocationIds);
        // console.log('selectedLocationIds', selectedLocationIds);
        getSalesTab(selectedLocationIds);
    };

    const handleCheckboxChangeCombo = (id) => {
        // console.log('dddddddddd', id);
        const updated = [...selectedCombo];
        const locationIndex = location1.findIndex((loc) => loc.id === id);
        updated[locationIndex] = !updated[locationIndex];
        setSelectedCombo(updated);

        setSelectAllCombo(updated.filter(Boolean).length === location1.length);
        const selectedLocationIds = location1
            .map((loc, index) => (updated[index] ? loc.id : null))
            .filter((id) => id !== null);
    };

    const handleSelectAllCombo = (e) => {
        const checked = e.target.checked;
        setSelectAllCombo(checked);

        const updatedSelected = new Array(location1.length).fill(checked);
        setSelectedCombo(updatedSelected);
        if (checked) {
            const allLocationIds = location1.map((loc) => loc.id);
            // console.log("All Selected Location IDs Combo:", allLocationIds);
        } else {
            console.log("No locations selected");
        }
    };
    const handleComboOk = () => {
        setRefresh(false);
        const selectedLocationIds = location1
            .map((loc, index) => (selectedCombo[index] ? loc.id : null))
            .filter((id) => id !== null);
        setGetSelectAllCombo(selectedLocationIds);
        // console.log('selectedLocationIds Combo', selectedLocationIds);
        getSalesTab1(selectedLocationIds);
    };

    const handelReset = () => {
        setSelected("");
    }
    const handelResetCombo = () => {
        setSelectedCombo("");
    }

    const handleSelectedComboProductTypes = (selectedData) => {
        setSelectedComboProductTypes(selectedData);
    };

    const handleChange = async (e) => {
        const value = e.target.value;
        const isMultiple = value.includes(',') && value.split(',').length > 1;

        if (!isMultiple) {

            const payload = {
                is_active: 1,
                id: value,
                limit: 0,
                pageNumber: 1,
            };

            try {
                const response = await APIS.Sales_Tab_List(payload);
                // console.log('API Response:', response);
                setChangePlayPoint(response?.data?.data[0]?.price_type || "Play Point");
            } catch (error) {
                console.error("API Error:", error);
                setChangePlayPoint("Play Point");
            }

            setSelectSalesTab(value);
        } else {

            if (value === 'Select' || value === '') {
                setSelectSalesTab(0);
                setChangePlayPoint("Play Point");
            } else {
                setSelectSalesTab(value);
                const selectedTab = salesTab.find(tab => tab.id === value);

                if (selectedTab) {
                    setChangePlayPoint(selectedTab.price_type);
                } else {

                    setChangePlayPoint("Play Point");
                }
            }
        }
        setError((prevErrors) => {
            const updatedErrors = { ...(prevErrors || {}) };
            delete updatedErrors.salesTab;
            return updatedErrors;
        });
    };

    const bindComboProduct = async (salesTabId) => {

        try {
            const saleTabId = salesTabId || 0;
            const isMultiple = saleTabId.length > 1 ? 1 : 0;
            const payload = {
                is_active: 1,
                is_combo: true,
                sale_tab_id: saleTabId,
                is_multiple: isMultiple,
            };
            const response = await APISSS.Get_Product_Type(payload);
            // console.log('combo', response?.data?.data);
            setComboProductType(response?.data?.data);
        } catch (error) {
            if (error.response.status == 403) {
                window.location.replace("/Login");
            }
            console.error("Error fetching combo product:", error);
        }
    };


    const handleChange2 = (e) => {
        const value = e.target.value;
        if (value === 'Select') {
            setSelectcomboSalesTab(0);
        } else {
            setSelectcomboSalesTab(value);
            bindComboProduct(value)

        }
        setError((prevErrors) => {
            const updatedErrors = { ...(prevErrors || {}) };
            delete updatedErrors.salesTab;
            return updatedErrors;
        });
    };

    const handleChange4 = (e) => {
        const value = e.target.value;
        setSelectedcomboProductType(value);
        setError((prevErrors) => {
            const updatedErrors = { ...(prevErrors || {}) };
            delete updatedErrors.salesTab;
            return updatedErrors;
        });
    };
    return (
        <div>
            <div>

                <button style={buttonStyle('single')} onClick={() => setActiveSection('single')}>Single Product</button>
                <button style={buttonStyle('combo')} onClick={() => setActiveSection('combo')}>Combo Product</button>

                {activeSection === 'single' && (

                    <div className="col-12 grid-margin stretch-card mt-3">
                        <div className="card">
                            <div className="card-body">
                                <h4 className="card-title">Single Product</h4>
                                <div className="forms-sample">
                                    <div className="row">
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label htmlFor="ddSalesType" className="form-label">
                                                    Center <span style={{ color: "red" }}>*</span>
                                                </label>
                                                <div className="dropdown">
                                                    <button
                                                        className="btn dropdown-toggle form-control text-start"
                                                        type="button"
                                                        aria-expanded="false"
                                                        data-bs-toggle="modal"
                                                        data-bs-target="#exampleModalCenter"
                                                    >
                                                        {(() => {
                                                            const selectedLocations = location
                                                                .filter((_, index) => selected[index])
                                                                .map((loc) => loc.name);

                                                            if (selectedLocations.length === 0) return "Select Center";

                                                            const combined = selectedLocations.join(", ");

                                                            return combined.length > 20 ? `${combined.slice(0, 20)}...` : combined;

                                                        })()}
                                                    </button>
                                                    {error.location && <small className="text-danger">{error.location}</small>}
                                                </div>
                                            </div>

                                        </div>

                                        <div className="col-md-4">
                                            <label>
                                                Sales Tab <span style={{ color: "red" }}>*</span>
                                            </label>

                                            <select
                                                className="form-select"
                                                id="ddSalesType"
                                                value={selectSalesTab}
                                                onChange={handleChange} // pass type to handler
                                            >
                                                <option value="">Select Sales Tab</option>
                                                {salesTab.map((tab, index) => (
                                                    <option key={index} value={tab.id}>
                                                        {tab.tab_name}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>


                                        {/* <div className="col-md-4">
                                            <label>Sales Tab <span style={{ color: "red" }}>*</span></label>

                                            <select
                                                className="form-select"
                                                id="ddSalesType"
                                                value={selectSalesTab}
                                                onChange={handleChange}
                                            >
                                                <option value="">Select Sales Tab</option>
                                                {salesTab.map((tab, index) => (
                                                    <option key={index} value={tab.id}>
                                                        {tab.tab_name}
                                                    </option>
                                                ))}
                                            </select>

                                        </div> */}

                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <ProductType
                                                    selectedProductType={productType}
                                                    setSelectedProductType={setProductType}
                                                    type={productTypeFlag}
                                                    SalesTab={selectSalesTab}
                                                // updateProductType={updateProductType}
                                                //onSalesTabChange={handleChange}
                                                />
                                                {/* <SalesProductType
                                                    salesTabId={productType}
                                                    trigger={true}
                                                    onSelectProductTypes={handleSelectedProductTypes}
                                                /> */}

                                            </div>
                                        </div>

                                    </div>
                                    <div className="row">
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label htmlFor="name">Name <span style={{ color: "red" }}>*</span></label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="txtname"
                                                    placeholder="Name"
                                                    value={name}
                                                    onChange={(e) => handleFieldChange(e, "name")}
                                                />
                                                {error.name && <small className="text-danger">{error.name}</small>}
                                            </div>
                                        </div>

                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label htmlFor="mobile">{changePlayPoint} (Normal) <span style={{ color: "red" }}>*</span></label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="txtmobile"
                                                    placeholder={changePlayPoint}
                                                    value={playPoint}
                                                    onChange={(e) => handleFieldChange(e, "playPoint")}
                                                />
                                                {error.playPoint && <small className="text-danger">{error.playPoint}</small>}
                                            </div>
                                        </div>

                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label htmlFor="mrp" className="form-label">
                                                    SkyCoins (SPCL) <span style={{ color: "red" }}>*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Enter SkyCoins Special"
                                                    id="skycoinsSpcl"
                                                    value={skycoinsSpcl}
                                                    onChange={(e) => handleFieldChange(e, "skycoinsSpcl")}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-2">
                                            <div className="form-group">
                                                <label htmlFor="mrp" className="form-label">
                                                    MRP
                                                </label>

                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Enter mrp"
                                                    id="mrp"
                                                    value={mrp}
                                                    onChange={(e) => handleFieldChange(e, "mrp")}
                                                />
                                                {error.mrp && <small className="text-danger">{error.mrp}</small>}

                                            </div>
                                        </div>


                                    </div>
                                    <div className="row">
                                        <div className="col-md-4">
                                            <TaxRateListList selectedTaxRate={singleTax} setSelectedTaxRate={setSingleTax}
                                                taxRates={singleTax}
                                            />
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label>Enter Hours</label>
                                                <select
                                                    className="form-select"
                                                    onChange={(e) => handleFieldChange(e, "timeValue")}
                                                    value={timeValue}
                                                >
                                                    {staticHours.map((hour) => (
                                                        <option key={hour} value={hour}>
                                                            {hour} hrs
                                                        </option>
                                                    ))}
                                                </select>

                                            </div>
                                        </div>

                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label htmlFor="ddltime" className="form-label">
                                                    Enter Minute
                                                </label>
                                                <select
                                                    className="form-select"
                                                    id="ddltime"
                                                    value={timeValue1}
                                                    // onChange={handleFieldChange}
                                                    onChange={(e) => handleFieldChange(e, "timeValue1")}
                                                >

                                                    {staticMinutes.map((hour) => (
                                                        <option key={hour} value={hour}>
                                                            {hour} min
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>


                                    </div>
                                    <div className="row">

                                        <div className="col-md-3">
                                            <label className="form-label">Is Recipe</label>
                                            <div className="form-check">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input ms-1"
                                                    checked={isRecipe}
                                                    onChange={() => setIsRecipe(!isRecipe)}
                                                    disabled={selectMachine !== ""}
                                                />
                                                <label className="form-check-label">
                                                    Enable Recipe
                                                </label>
                                            </div>
                                        </div>

                                       <div className="col-md-3">
                                            <label className="form-label">Expose Api</label>
                                            <div className="form-check">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input ms-1"
                                                    checked={curiousKids}
                                                    onChange={() => setCuriousKids(!curiousKids)}
                                                  
                                                />
                                                <label className="form-check-label">
                                                    Enable Expose Api
                                                </label>
                                            </div>
                                        </div> 

                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label htmlFor="name">Description</label>
                                                <textarea
                                                    type="text"
                                                    className="form-control"
                                                    id="txtname"
                                                    placeholder="Description"
                                                    rows={1}
                                                    value={description}
                                                    onChange={(e) => handleFieldChange(e, "description")}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <button
                                        type="button"
                                        onClick={addSingldProduct}
                                        className="btn btn-primary me-2"

                                    >
                                        Submit
                                    </button>

                                    <button className="btn btn-light" onClick={handleCancel}>Cancel</button>

                                </div>

                            </div>

                        </div>
                    </div>
                )}
                {activeSection === 'combo' && (
                    <div className="card mt-3">
                        <div className="card-body">
                            <h4 className="card-title">Combo Product</h4>
                            <div className="forms-sample">
                                <div className="row">
                                    <div className="col-md-4">

                                        <div className="form-group">
                                            <label htmlFor="ddSalesType" className="form-label">
                                                Center <span style={{ color: "red" }}>*</span>
                                            </label>
                                            <div className="dropdown">
                                                <button
                                                    className="btn dropdown-toggle form-control text-start"
                                                    type="button"
                                                    aria-expanded="false"
                                                    data-bs-toggle="modal"
                                                    data-bs-target="#exampleModalComboCenter"
                                                >
                                                    {(() => {
                                                        const selectedLocations = location1
                                                            .filter((_, index) => selectedCombo[index])
                                                            .map((loc) => loc.name);
                                                        if (selectedLocations.length === 0) return "Select Center";
                                                        const combined = selectedLocations.join(", ");
                                                        return combined.length > 20 ? `${combined.slice(0, 20)}...` : combined;
                                                    })()}
                                                </button>
                                                {error.location && <small className="text-danger">{error.location}</small>}
                                            </div>
                                        </div>

                                    </div>

                                    <div className="col-md-4">
                                        <label>Sales Tab <span style={{ color: "red" }}>*</span></label>
                                        <select className="form-select"
                                            id="ddSalesType"
                                            value={selectcomboSalesTab}
                                            onChange={handleChange2}
                                        >
                                            <option>Select</option>
                                            {salesTab1.map((item) => (
                                                <option key={item.id} value={item.id}>
                                                    {item.tab_name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label htmlFor="ddSalesType" className="form-label">
                                                Product Type <span style={{ color: "red" }}>*</span>
                                            </label>
                                            <select
                                                className="form-select"
                                                id="ddSalesType"
                                                value={selectedcomboProductType}
                                                onChange={handleChange4}
                                            >
                                                <option>Select</option>
                                                {Array.isArray(comboProductType) && comboProductType.map((item) => (
                                                    <option key={item.id} value={item.id}>
                                                        {item.name}
                                                    </option>
                                                ))}
                                            </select>
                                            {error.comboProductType && <small className="text-danger">{error.comboProductType}</small>}
                                        </div>
                                      
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label htmlFor="name">Name <span style={{ color: "red" }}>*</span></label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="txtname"
                                                placeholder="Name"
                                                value={comboName}
                                                onChange={(e) => handleFieldChange1(e, "comboName")}
                                            />
                                            {error.comboName && <small className="text-danger">{error.comboName}</small>}
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label htmlFor="mobile">Price <span style={{ color: "red" }}>*</span></label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="txtPrice"
                                                placeholder="Price"
                                                value={comboPrice}
                                                disabled={true}
                                                onChange={(e) => handleFieldChange1(e, "comboPrice")}
                                            />
                                            {error.comboPrice && <small className="text-danger">{error.comboPrice}</small>}
                                        </div>
                                    </div>

                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label htmlFor="mobile">Special Price <span style={{ color: "red" }}>*</span></label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="txtSpecialPrice"
                                                placeholder="Special Price"
                                                value={comboSpecialPrice}
                                                disabled={true}
                                                onChange={(e) => handleFieldChange1(e, "comboSpecialPrice")}
                                            />
                                            {error.comboSpecialPrice && <small className="text-danger">{error.comboSpecialPrice}</small>}
                                        </div>
                                    </div>

                                    {/* <div className="col-md-4">
                                        <TaxRateListList selectedTaxRate={comboTax} setSelectedTaxRate={setComboTax}
                                            taxRates={comboTax}
                                        />
                                    </div> */}
                                </div>
                                {isAddProductList && (
                                    <section>
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="table-responsive">
                                                    {rows.length > 0 && (
                                                        <table className="table table-bordered text-center align-middle" style={{ width: "120%" }}>
                                                            <thead className="table-dark">
                                                                <tr>
                                                                    <th style={{ width: "50px" }}>Action</th>
                                                                    <th style={{ width: "150px" }}>Product Name</th>
                                                                    <th style={{ width: "250px" }}>Time</th>
                                                                    <th style={{ width: "100px" }}>Qty</th>
                                                                    <th style={{ width: "30px" }}>Discounted Price</th>
                                                                    <th style={{ width: "30px" }}>Discounted Price(SPCL)</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {rows.map((row, index) => (
                                                                    <tr key={index}>
                                                                        <td>
                                                                            <button
                                                                                className="btn btn-danger btn-sm"
                                                                                onClick={() => handleRemoveRow(index)}
                                                                                style={{ backgroundColor: "red" }}
                                                                            >
                                                                                <span className="fa fa-trash-o text-white"></span>
                                                                            </button>
                                                                        </td>
                                                                        <td>{row.productName}</td>

                                                                        <td>
                                                                            {row.time ? (
                                                                                `${row.time}`
                                                                            ) : (
                                                                                <div className="row">
                                                                                    <div className="col-6">
                                                                                        <div className="form-group mt-2">
                                                                                            <label>Enter Hours</label>
                                                                                            <select
                                                                                                className="form-select"
                                                                                                value={row.hours}
                                                                                                onChange={(e) => handleInputChange(index, "hours", e.target.value)}
                                                                                            >
                                                                                                {staticHours.map((hour) => (
                                                                                                    <option key={hour} value={hour}>
                                                                                                        {hour} hrs
                                                                                                    </option>
                                                                                                ))}
                                                                                            </select>
                                                                                        </div>
                                                                                    </div>

                                                                                    <div className="col-6">
                                                                                        <div className="form-group">
                                                                                            <label htmlFor="ddltime" className="form-label">
                                                                                                Enter Minute
                                                                                            </label>
                                                                                            <select
                                                                                                className="form-select"
                                                                                                id="ddltime"
                                                                                                value={row.minutes}
                                                                                                onChange={(e) => handleInputChange(index, "minutes", e.target.value)}
                                                                                            >
                                                                                                {staticMinutes.map((minute) => (
                                                                                                    <option key={minute} value={minute}>
                                                                                                        {minute} min
                                                                                                    </option>
                                                                                                ))}
                                                                                            </select>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            )}
                                                                        </td>

                                                                        <td>
                                                                            <input
                                                                                type="text"
                                                                                className="form-control"
                                                                                placeholder="Qty"
                                                                                value={row.qty}
                                                                                onChange={(e) => handleInputChange(index, "qty", e.target.value)}
                                                                            />
                                                                            {error.qty && <small className="text-danger">{error.qty}</small>}
                                                                        </td>
                                                                        <td>
                                                                            <input
                                                                                type="text"
                                                                                className="form-control"
                                                                                placeholder="Discounted Price"
                                                                                value={row.discounted_price}
                                                                                onChange={(e) => handleInputChange(index, "discounted_price", e.target.value)}
                                                                            />
                                                                            {error.discounted_price && <small className="text-danger">{error.discounted_price}</small>}
                                                                        </td>

                                                                        <td>
                                                                            <input
                                                                                type="text"
                                                                                className="form-control"
                                                                                placeholder="Discounted Price Special"
                                                                                value={row.discounted_price_special}
                                                                                onChange={(e) => handleInputChange(index, "discounted_price_special", e.target.value)}
                                                                            />
                                                                            {error.discounted_price_special && <small className="text-danger">{error.discounted_price_special}</small>}
                                                                        </td>

                                                                    </tr>
                                                                ))}

                                                            </tbody>
                                                        </table>
                                                    )}
                                                </div>

                                            </div>
                                        </div>
                                        {locationData.length > 0 && (
                                            <div className="row mt-4">
                                                <h5>Add SubProduct</h5>
                                                <div className="col-md-6">
                                                    {
                                                        refresh ?
                                                            <ProductType selectedProductType={searchProductType} setSelectedProductType={setSearchProductType} type={productTypeFlag2} location_id={locationData} />
                                                            : <></>
                                                    }
                                                </div>
                                                <div className="col-md-3">
                                                    <button className="btn btn-success mt-4"
                                                        type="button" onClick={handleSearchClick}>Search</button>
                                                </div>
                                            </div>
                                        )}
                                    </section>


                                )}
                                {/* Yaha */}
                                <div className="mt-1"> <button type="button" className="btn btn-primary me-2" onClick={addComboProduct} style={{ display: isEditingCombo ? "none" : "inline-block" }} >
                                    Submit
                                </button>

                                    <button className="btn btn-light" onClick={handleCancel}>Cancel</button></div>


                            </div>
                        </div>
                    </div>
                )}
                {isModal && (
                    <>
                        <div className="modal-backdrop show" style={{ filter: "blur(5px)" }}></div>
                        <section>
                            <div className="modal show d-block" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
                                <div className="modal-dialog modal-dialog-centered modal-lg" style={{ width: "600px" }}>
                                    <div className="modal-content" style={{ backgroundColor: "#fff" }}>
                                        <div className="modal-header">
                                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={() => setIsModal(false)}></button>
                                        </div>
                                        <div className="modal-body">
                                            <div className="table-responsive">
                                                <table className="table table-bordered text-center">
                                                    <thead>
                                                        <tr>
                                                            <th style={{ width: "100px" }}>SrNo</th>
                                                            <th style={{ width: "200px" }}>Action</th>
                                                            <th>Product Name</th>
                                                            <th>Time</th>

                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {searchProductList.map((item, index) => (
                                                            // console.log("item data...", item),
                                                            <tr key={item.id}>
                                                                <td>{(currentPage1 - 1) * perPage + index + 1}</td>
                                                                <td>
                                                                    <button className="btn btn-sm btn-success" onClick={() => handleAddRow(item.id, item.name, item.time, 'down')}>Add</button>
                                                                </td>
                                                                <td>{item.name}</td>
                                                                <td>{item.time}</td>

                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                                <nav aria-label="Page navigation example">
                                                    <ul className="pagination justify-content-center mt-4">
                                                        <li className={`page-item ${currentPage1 === 1 ? "disabled" : ""}`}>
                                                            <button className="page-link" onClick={() => handlePageChange1(currentPage1 - 1)} disabled={currentPage1 === 1}>Previous</button>
                                                        </li>
                                                        {Array.from({ length: totalPages1 }, (_, index) => (
                                                            <li key={index + 1} className={`page-item ${currentPage1 === index + 1 ? "active" : ""}`}>
                                                                <button className="page-link" onClick={() => handlePageChange1(index + 1)}>{index + 1}</button>
                                                            </li>
                                                        ))}
                                                        <li className={`page-item ${currentPage1 === totalPages1 ? "disabled" : ""}`}>
                                                            <button className="page-link" onClick={() => handlePageChange1(currentPage1 + 1)} disabled={currentPage1 === totalPages1}>Next</button>
                                                        </li>
                                                    </ul>
                                                </nav>
                                            </div>
                                        </div>
                                        <div className="modal-footer">
                                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal" onClick={() => setIsModal(false)}>Close</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </>
                )}

                <section>
                    <div className="modal fade" id="exampleModalCenter" tabIndex="-1" aria-hidden="true">
                        <div className="modal-dialog modal-lg">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">Select Center</h5>
                                    <button type="button" className="btn-close" onClick={handelReset} data-bs-dismiss="modal" aria-label="Close"></button>
                                </div>
                                <div className="modal-body">
                                    <div className="container ms-3 me-2">
                                        <div className="form-check mb-3" style={{ display: "flex", alignItems: "center" }}>
                                            <input
                                                type="checkbox"
                                                className="form-check-input"
                                                id="select-all"
                                                checked={selectAll}
                                                onChange={handleSelectAll}
                                                style={{ "box-shadow": "0 0 0 1px blue" }}
                                            />
                                            <label htmlFor="select-all" className="form-check-label"
                                                style={{ marginLeft: "8px", cursor: "pointer", userSelect: "none" }}
                                            >Select All</label>
                                        </div>

                                        <div className="row">
                                            {location.map((loc, index) => (
                                                <div className="col-md-3" key={loc.id}>
                                                    <div className="form-check" style={{ display: "flex", alignItems: "center" }}>
                                                        <input
                                                            type="checkbox"
                                                            className="form-check-input"
                                                            id={`loc-${index}`}
                                                            checked={selected[index] || false}
                                                            onChange={() => handleCheckboxChange(loc.id)}
                                                            style={{ "box-shadow": "0 0 0 1px blue" }}
                                                        />
                                                        <label className="form-check-label" htmlFor={`loc-${index}`}
                                                            style={{ marginLeft: "8px", cursor: "pointer", userSelect: "none" }}
                                                        >
                                                            {loc.name}
                                                        </label>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>

                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" data-bs-dismiss="modal" onClick={handelReset}>Close</button>
                                    <button type="button" className="btn btn-primary" onClick={handleOk} data-bs-dismiss="modal" disabled={selected.length === 0}>OK</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>


                <section>
                    <div className="modal fade" id="exampleModalComboCenter" tabIndex="-1" aria-hidden="true">
                        <div className="modal-dialog modal-lg">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">Select Center's</h5>
                                    <button type="button" className="btn-close" onClick={handelReset} data-bs-dismiss="modal" aria-label="Close"></button>
                                </div>
                                <div className="modal-body">
                                    <div className="container ms-3 me-2">
                                        <div className="form-check mb-3" style={{ display: "flex", alignItems: "center" }}>
                                            <input
                                                type="checkbox"
                                                className="form-check-input"
                                                id="select-all"
                                                checked={selectAllCombo}
                                                onChange={handleSelectAllCombo}
                                                style={{ "box-shadow": "0 0 0 1px blue" }}
                                            />
                                            <label htmlFor="select-all" className="form-check-label"
                                                style={{ marginLeft: "8px", cursor: "pointer", userSelect: "none" }}
                                            >Select All</label>
                                        </div>

                                        <div className="row">
                                            {location1.map((loc, index) => (
                                                <div className="col-md-3" key={loc.id}>
                                                    <div className="form-check" style={{ display: "flex", alignItems: "center" }}>
                                                        <input
                                                            type="checkbox"
                                                            className="form-check-input"
                                                            id={`loc-${index}`}
                                                            checked={selectedCombo[index] || false}
                                                            onChange={() => handleCheckboxChangeCombo(loc.id)}
                                                            style={{ "box-shadow": "0 0 0 1px blue" }}
                                                        />
                                                        <label className="form-check-label" htmlFor={`loc-${index}`}
                                                            style={{ marginLeft: "8px", cursor: "pointer", userSelect: "none" }}
                                                        >
                                                            {loc.name}
                                                        </label>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>

                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" data-bs-dismiss="modal" onClick={handelResetCombo}>Close</button>
                                    <button type="button" className="btn btn-primary" onClick={handleComboOk} data-bs-dismiss="modal"
                                        disabled={selectedCombo.length === 0}
                                    >OK</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

            </div>
            <ToastContainer />
            <ProductList type={activeSection} />


        </div>
    );
};

export default Product;
